import React from 'react';
import ReactDOM from 'react-dom';
import bemBlock from '@gik/core/utils/bemBlock';
import { Button, FormField, Form, FormSchemaEntry } from '@gik/ui';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import { resetPassword } from '@gik/api/users/auth';

const blockName = 'forgot-password-form';

const schema: FormSchemaEntry[] = [{ placeholder: 'Email address', name: 'email', type: 'email', required: true }];
export interface IForgotPasswordFormValues {
  email: string;
  password: string;
  rememberMe: boolean;
}
export interface IForgotPasswordFormProps {
  buttonsPortal?: () => HTMLElement;
  onSuccess?: () => void;
}

export default function ForgotPasswordForm({ buttonsPortal, onSuccess }: IForgotPasswordFormProps) {
  const bem = bemBlock(blockName);
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = React.useState<string>();

  async function handleSubmit(values: IForgotPasswordFormValues) {
    setErrorMessage(null);
    const response = await resetPassword(values.email);

    if (response === true) {
      if (onSuccess) onSuccess();
    } else {
      // TODO: get this message form the backend when it has been updated
      setErrorMessage('There is no account associated with this email address');
    }
  }

  const formId = 'forgotPasswordForm';

  return (
    <Form
      onSubmit={handleSubmit}
      schema={schema}
      vertical
      className={bem('form')}
      id={formId}
      render={({ valid, submitting }) => {
        const buttons = (
          <>
            <Button
              className={bem('btnSubmit')}
              variant="primary"
              type="submit"
              size="xl"
              loading={submitting}
              disabled={!valid}
              form={formId}
            >
              {t(translationKeys.formSubmitButton)}
            </Button>
          </>
        );

        return (
          <>
            <div className={bem('description')}>{t(translationKeys.description)}</div>
            <FormField name="email" />

            {errorMessage && <div className="gik-form__form-error">{errorMessage}</div>}

            {/* TODO: try to abstract this logic */}
            {buttonsPortal && ReactDOM.createPortal(buttons, buttonsPortal())}
            {!buttonsPortal && buttons}
          </>
        );
      }}
    />
  );
}
